export const REGEX = {
    NUMBER_ONLY_REGEX:/^[0-9]*$/,
    NOT_START_WITH_0_REGEX:/^[1-9]\d*$/,
    NAME_VALIDATION:/^[a-zA-Z&-\s]+$/,
    PAN_NUMBER_REGEX:/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    GST_REGISTRATION_NO:/^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
    AADHAR_CARD_NUMBER_REGEX:/^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$/
}